import React from "react";
import { Flame } from "lucide-react";
import { useTheme } from "../../lib/theme-context";
import { useSystemBranding } from "../../lib/system-branding-context";

export default function AppBrandMark({
  logoUrl: logoUrlOverride,
  showText = true,
  containerClassName = "flex items-center gap-2.5 min-w-0",
  badgeClassName = "h-10 w-10",
  iconClassName = "h-5 w-5",
  textClassName = "font-display font-semibold tracking-tight",
  imageClassName = "block h-auto max-h-10 w-auto max-w-[220px] object-contain",
  glowClassName = "brand-glow",
}) {
  const { isDark } = useTheme();
  const { branding } = useSystemBranding();
  const logoUrl = logoUrlOverride || (
    isDark ? branding.dark_logo_url || branding.light_logo_url : branding.light_logo_url || branding.dark_logo_url
  );

  if (logoUrl) {
    return (
      <div data-testid="app-brand-mark" data-brand-mode="logo" className={containerClassName}>
        <img src={logoUrl} alt="FyreCRM" className={imageClassName} />
      </div>
    );
  }

  return (
    <div data-testid="app-brand-mark" data-brand-mode="fallback" className={containerClassName}>
      <div
        data-testid="app-brand-fallback-badge"
        className={`${badgeClassName} shrink-0 rounded-lg flex items-center justify-center text-primary-foreground ${glowClassName}`}
        style={{ background: "var(--brand)" }}
      >
        <Flame className={iconClassName} />
      </div>
      {showText ? <span className={textClassName}>FyreCRM</span> : null}
    </div>
  );
}
